module.exports = __webpack_public_path__ + "static/media/hero.1fc94714.PNG";